import { Head } from '@inertiajs/react'
import type { SeoProps } from '../types'

// "<" is escaped so no string in the data can close the script element.
export const jsonLdText = (data: Record<string, unknown>) => JSON.stringify(data).replace(/</g, '\\u003c')

// Server-built SEO data in, tags out. `title` overrides only the visible title
// (the signed-in home page); description and canonical always come from the server.
// JSON-LD sits in the body, which Google reads.
export default function Seo({ seo, title }: { seo: SeoProps; title?: string }) {
  return <>
    <Head title={title ?? seo.title}>
      <meta head-key="description" name="description" content={seo.description} />
      <link head-key="canonical" rel="canonical" href={seo.canonical_url} />
    </Head>
    {seo.json_ld && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdText(seo.json_ld) }} />}
  </>
}
